<template>
  <div class="d-flex flex-no-wrap justify-space-between elevation-2">
    <div class="pt-1 pl-4 pb-1">
      <div class="subtitle-2 grey--text text--darken-2">{{_getDocumentTitle(document.name)}} {{document.doc_id}} <span class="grey--text text--darken-1">({{_getStoreName(document.skladi_id)}})</span></div>
      <div class="caption grey--text text--darken-1">{{document.kontragenti_name}}</div>
    </div>
    <div>
      <v-btn icon large @click="$emit('closeDialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'dialogToolbar',
  props: {
    document: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('minsk', {
      _getStoreName: 'getStoreName',
      _getDocumentTitle: 'getDocumentTitle'
    })
  }
}
</script>

<style scoped>

</style>
